// import Fly from 'flyio/dist/npm/fly'
import store from '../store/index'
import Vue from "vue";
// const fly = new Fly()
import axios from 'axios'
const fly = axios.create({
    timeout: 6000 // 请求超时时间
})
const host = 'http://api.iguaguajiao.com:8888'
// 添加请求拦截器
fly.interceptors.request.use((request) => {
	request.baseURL  =  host;
  // console.log(request)
  if (request.method == 'get' && request[0]) {
    request.url = `${request.url}?${request[0]}`
  }
	// let token = getToken();
	// if(token){
	request.headers = {
		'content-type': 'application/json'
    // 'content-type': 'multipart/form-data'
	}
	// }
	let authParams = {
		// serversideId: 2,
		// token
		// 公共参数
	}
	let res = request.body

    if (Array.isArray(res)) {

    } else {
        request.body && Object.keys(request.body).forEach((val) => {
            if (request.body[val] === '') {
                delete request.body[val]
            }
            ;
        })
        request.body = {
            ...res,
            ...authParams
        }
    }
    // console.log(request.body)
    return request
})

// 添加响应拦截器
fly.interceptors.response.use(
    function (response) {
        // wx.hideLoading();
        if (response.data.code != '000000') {
          // Vue.toast(response.data.message)
            return Promise.reject(response)
        } else {
            return response.data // 请求成功之后将返回值返回
        }
    },
    (err) => {

        return Promise.reject(err.response)
    }
)

export default fly;
